<template>
    <div class="purchase-page">
        <!-- 头部组件 -->
        <Header />
        <div>
            <!-- 导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '2',
                        },
                    }">供应大厅</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.back()">商品详情</el-breadcrumb-item>
                    <el-breadcrumb-item>立即购买</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 主要内容 -->
            <div class="main-content">
                <!-- 收货地址 -->
                <!-- <div class="address-section">
                    <div class="section-title">
                        <div class="title-container">
                            <div class="line"></div>
                            <span>收货地址</span>
                        </div>
                        <el-button type="text" class="add-address-btn" @click="openAddressDialog">+ 新增收货地址</el-button>
                    </div>
                    <div class="address-list">
                        <div class="address-card" v-for="(address, index) in addresses" :key="index"
                            @click="selectAddress(address, index)">
                            <img src="../../assets/images/26.png" alt="" v-if="selectedAddressIndex == index">
                            <img src="../../assets/images/27.png" alt="" v-else>
                            <div class="address-header">
                                <span class="name">{{ address.real_name }}({{ address.sex === 1 ? '先生' : '女士' }})</span>
                                <span class="phone">{{ address.mobile }}</span>
                            </div>
                            <div class="address-content">
                                {{ address.province }}{{ address.city }}{{ address.district }}{{ address.detail }}
                            </div>
                            <div class="address-footer">
                                <el-button v-if="address.is_default == 1" type="primary" size="small" plain>
                                    默认地址
                                </el-button>
                                <el-button v-else type="primary" size="small" plain>
                                    设置为默认地址
                                </el-button>
                                <el-button type="text" size="small">编辑</el-button>
                                <el-button type="text" size="small">删除</el-button>
                            </div>
                        </div>
                    </div>
                </div> -->


                <ShippingAddress :addresses="addresses" :selectedAddressIndex="selectedAddressIndex"
                    @selectAddress="selectAddress" @setAddressFn="setAddressFn" @addressListUpdated="getAddressList" />


                <!-- 产品信息 -->
                <div class="product-section">
                    <div class="section-title">
                        <div class="title-container">
                            <div class="line"></div>
                            <span>产品信息</span>
                        </div>
                    </div>
                    <div class="product-table">
                        <div class="table-header">
                            <!-- <div class="col col-1">商品信息</div> -->
                            <div class="col col-2">商品信息</div>
                            <div class="col col-3">单价</div>
                            <div class="col col-4">数量</div>
                            <!-- <div class="col col-5">运费</div> -->
                            <div class="col col-6">小计</div>
                        </div>
                        <div class="table-body">
                            <div class="product-item" v-for="(item, index) in selectedSkus" :key="index">
                                <!-- <div class="col col-1">
                                    <div class="supplier-info">{{ item.supplier }}</div>
                                </div> -->
                                <div class="col col-2">
                                    <div class="product-detail">
                                        <img :src="item.spec_img || item.goods_thumb" alt="商品图片" class="product-image">
                                        <div class="product-info">
                                            <div class="product-name">{{ item.key_name || item.goods_name }}</div>
                                            <!-- <div class="item-spec">{{ item.spec }}</div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-3">¥{{ item.shop_price }}/{{ item.unit }}</div>
                                <div class="col col-4">{{ item.num }}</div>
                                <!-- <div class="col col-5">{{ item.num }}</div> -->
                                <div class="col col-6">¥{{ item.shop_price * item.num }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 优惠券和备注 -->
                <div class="coupon-note-section">
                    <div class="coupon-section">
                        <div class="section-title">
                            <i class="el-icon-tickets"></i> 优惠券 (剩余{{ coupons.length || 0 }}张)
                        </div>

                        <div class="coupon-box" @click="openCouponDialog">
                            <span>{{ selectedCoupon ? `¥${selectedCoupon.money} ${selectedCoupon.coupon_name}` :
                                '请选择优惠券' }}</span>
                            <img src="../../assets/images/28.png" alt="">
                        </div>


                    </div>
                    <div class="note-section">
                        <div class="section-title">
                            <i class="el-icon-edit"></i> 备注
                        </div>
                        <el-input type="text" placeholder="请输入备注" class="note-input" v-model="remark"></el-input>
                    </div>
                </div>

                <!-- 订单总计 -->
                <div class="order-summary">
                    <div class="summary-item">
                        <span class="label">{{ selectedSkus.length || 0 }}件商品：</span>
                        <span class="value">¥{{ totalPrice }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">优惠：</span>
                        <span class="value discount">-¥{{ selectedCoupon ? selectedCoupon.money : 0.00 }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">运费：</span>
                        <span class="value">{{ is_shipping == 1 ? '包邮' : '¥' + yunfeiPrice }}</span>
                    </div>
                    <div class="summary-total">
                        <span class="label">应付金额：</span>
                        <span class="value total">¥{{ shifuPrice }}</span>
                    </div>
                    <el-button type="primary" class="submit-btn" @click="submitOrder">提交订单</el-button>
                </div>
            </div>

        </div>

        <!-- 底部组件 -->
        <Footer />

        <!-- 优惠券弹窗 -->
        <el-dialog title="优惠券" :visible.sync="couponDialogVisible" width="972px" center :close-on-click-modal="true">
            <div class="coupon-list">
                <div class="coupon-item" v-for="(coupon, index) in coupons" :key="index"
                    :class="{ 'is-use': coupon.is_use == 1 }">
                    <div class="coupon-left">
                        <div class="coupon-amount">¥{{ coupon.money }}</div>
                        <div class="coupon-condition">满{{ coupon.min_order_money }}减{{ coupon.money }}</div>
                    </div>
                    <div class="coupon-right">
                        <div class="coupon-name">{{ coupon.coupon_name }}</div>
                        <div class="coupon-scope">{{ coupon.content }}</div>
                        <div class="coupon-expiry">有效期至: {{ coupon.end_time }}</div>
                        <el-button type="primary" size="small" plain @click="useCoupon(coupon)"
                            v-if="coupon.is_use == 1">
                            使用
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 在优惠券弹窗之后添加新增地址弹窗 -->

        <!-- 在script部分的data中添加变量 -->
    </div>
</template>

<script>
// 导入头部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import ShippingAddress from './components/ShippingAddress.vue'
export default {
    name: 'PurchasePage',
    components: {
        // 注册头部组件
        Header,
        // 注册底部组件
        Footer,
        ShippingAddress
    },
    data() {
        return {
            addresses: [],
            selectedSkus: [],
            selectedAddress: '',
            selectedAddressIndex: '',
            remark: '',
            youhuivalue: 0,
            // 优惠券弹窗相关数据
            couponDialogVisible: false,
            coupons: [],
            selectedCoupon: null,
            totalPrice: 0,
            // shifuPrice: 0,
            yunfeiPrice: 0,
            is_shipping: 0,

            addressDialogVisible: false,

        }
    },
    // purchase 页面
    created() {
        // 通过 $route.params 获取
        this.selectedSkus = this.$route.params.selectedSkus || [];
        this.totalPrice = this.$route.params.totalPrice;
        console.log('接收的规格数据：', this.selectedSkus);
    },
    mounted() {
        this.getAddressList();
        this.getCouponList();
    },
    computed: {
        // 计算应付金额
        shifuPrice() {
            // 安全获取总价格，确保转换为数字
            const totalPrice = Number(this.totalPrice) || 0;

            // 安全获取优惠金额，优惠券不存在时优惠金额为0
            const discountAmount = this.selectedCoupon ? Number(this.selectedCoupon.money) || 0 : 0;

            // 安全获取运费，确保转换为数字
            const shippingFee = Number(this.yunfeiPrice) || 0;

            // 按照新规则计算：总价格 - 优惠金额 + 运费
            const actualPrice = totalPrice - discountAmount + shippingFee;

            // 确保结果不为负数，保留两位小数
            return Math.max(0, actualPrice).toFixed(2);
        }
    },
    methods: {
        // 获取收货地址列表
        getAddressList() {
            this.$api.getAddressList().then(res => {
                this.addresses = res.data || [];
                this.addresses.forEach((item, index) => {
                    if (item.is_default == 1) {
                        this.selectedAddress = item.aid;
                        this.selectedAddressIndex = index;
                    }
                })
                this.getBaoyouStatus()
            }).catch(err => {
                console.error('获取收货地址列表失败:', err);
                this.$message.error(err);
            })
        },
        // 获取优惠券列表
        getCouponList() {
            let data = {
                min_order_money: this.totalPrice,
                type: 2
            }
            this.$api.getCouponList(data).then(res => {
                this.coupons = res || [];

                console.log(this.coupons, 'content');

            }).catch(err => {
                console.error('获取优惠券列表失败:', err);
                this.$message.error(err);
            })
        },

        // 选择地址
        selectAddress(address) {
            this.selectedAddress = address;
            this.getBaoyouStatus()
        },
        // 设置默认地址
        setAddressFn(address) {
            this.getAddressList();
            this.selectedAddress = address.aid;
        },


        // 打开优惠券弹窗
        openCouponDialog() {
            this.couponDialogVisible = true;
        },

        // 使用优惠券
        useCoupon(coupon) {
            this.selectedCoupon = coupon;
            this.selectedCouponAid = coupon.aid;
            this.couponDialogVisible = false;
            this.$message.success('优惠券使用成功');
        },


        // 获取是否包邮
        getBaoyouStatus() {
            let data = {
                goods_id: this.$route.query.id || this.$route.params.id,
                // lat: this.lat,
                // lng: this.lng,
                address_id: this.selectedAddress.aid
            }
            this.$dapi.getProductInfo(data).then(res => {
                this.is_shipping = res.is_shipping;
                this.yunfeiPrice = res.shipping_price;
            }).catch(err => {
                // console.error('获取商品详情信息失败:', err);
                this.$message.error(err);
            })
        },

        // 提交订单
        submitOrder() {
            // console.log(this.selectedAddress);
            // return
            if (!this.selectedAddress) {
                this.$message.error('请选择收货地址');
                return;
            }
            if (!this.selectedSkus.length) {
                this.$message.error('请选择商品');
                return;
            }
            let data = {
                address_id: this.selectedAddress,
                order_info: JSON.stringify(this.selectedSkus),
                remark: this.remark,
                goods_id: this.$route.query.id,
                coupon_id: this.selectedCoupon ? this.selectedCoupon.id : '',
            }

            console.log(data, 'data');

            // return
            this.$dapi.submitOrder(data).then(res => {
                this.$message.success('订单提交成功');

                let info = res

                this.$router.push({
                    name: 'Payment', // 用 name 跳转，而非 path
                    params: {
                        time: info.last_time,
                        money: this.shifuPrice,
                        order_type: 3,
                        order_config_id: 14
                    },
                    // 如需保留 query 参数，可加 query
                    query: { order_sn: info.order_sn }
                });
            }).catch(err => {
                this.$message.error(err);
            })
        },

        openAddressDialog() {
            this.addressDialogVisible = true;
        },
        saveAddress() {
            // 这里可以添加表单验证和保存逻辑
            console.log('保存地址:', this.newAddress);
            // 调用API保存地址
            // this.$api.saveAddress(this.newAddress).then(res => {
            //   this.$message.success('地址保存成功');
            //   this.addressDialogVisible = false;
            //   this.getAddressList(); // 重新获取地址列表
            // }).catch(err => {
            //   this.$message.error('地址保存失败');
            // });
            this.$message.success('地址保存成功');
            this.addressDialogVisible = false;
        }
    }
}
</script>

<style scoped>
.purchase-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.breadcrumb {
    padding: 24px 0 20px 0;
    width: 1200px;
    margin: 0 auto;
}

.main-content {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 8px;
    color: #409eff;
}

.title-container {
    display: flex;
    align-items: center;
}

.line {
    width: 4px;
    height: 18px;
    background: #286CED;
    border-radius: 0px 0px 0px 0px;
    margin-right: 12px;
}

/* 收货地址样式 */
.address-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.add-address-btn {
    margin-left: auto;
    color: #FF9735;
}

.address-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.address-card {
    width: 300px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    text-align: left;
}

.address-card img {
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 0;
    right: 0;
}

.address-card:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.address-header {
    margin-bottom: 10px;
}

.name {
    font-weight: bold;
    margin-right: 10px;
}

.phone {
    color: #666;
}

.address-content {
    margin-bottom: 15px;
    color: #666;
    line-height: 1.5;
}

.address-footer {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* 产品信息样式 */
.product-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.product-table {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    overflow: hidden;
}

.table-header {
    display: flex;
    background-color: #f5f7fa;
    padding: 10px 15px;
    font-weight: bold;
    border-bottom: 1px solid #e6e6e6;
}

.table-body {
    padding: 15px;
}

.product-item {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e6e6e6;
}

.product-item:last-child {
    border-bottom: none;
}

.col {
    text-align: center;
}

.col-1 {
    width: 10%;
}

.col-2 {
    width: 40%;
    text-align: left;
}

.col-3,
.col-4,
.col-5,
.col-6 {
    /* width: 12.5%; */
    flex: 1;
    text-align: center;
}

.product-detail {
    display: flex;
    align-items: center;
}

.product-image {
    width: 80px;
    height: 80px;
    margin-right: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

.product-info {
    flex: 1;
    text-align: left;
}

.product-name {
    margin-bottom: 5px;
    font-weight: bold;
}

.product-spec {
    color: #666;
    font-size: 14px;
}

/* 优惠券和备注样式 */
.coupon-note-section {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.coupon-section,
.note-section {
    flex: 1;
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.coupon-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #DDDDDD;
    padding: 14px 16px;
    font-size: 16px;
    color: #999999;
    cursor: pointer;
}

.coupon-box img {
    width: 9px;
    height: 14px;
}

.coupon-select {
    width: 100%;
}

.note-input {
    width: 100%;
    height: 80px;
}

/* 订单总计样式 */
.order-summary {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: right;
}

.summary-item {
    margin-bottom: 10px;
}

.summary-total {
    margin: 20px 0;
    font-size: 18px;
    font-weight: bold;
}

.label {
    margin-right: 20px;
    color: #666;
}

.value {
    color: #333;
}

.discount {
    color: #f56c6c;
}

.total {
    color: #f56c6c;
    font-size: 24px;
}

.submit-btn {
    width: 200px;
    height: 40px;
    font-size: 16px;
}

/* 优惠券弹窗样式 */
.coupon-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
}

.coupon-item {
    display: flex;
    width: 450px;
    height: 120px;
    background: linear-gradient(to right, #666 0%, #666 30%, #ffffff 30%, #ffffff 100%);

    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
}

.is-use {
    background: linear-gradient(to right, #ff6b6b 0%, #ff6b6b 30%, #ffffff 30%, #ffffff 100%) !important;
}

/* .coupon-item::before {
    content: '';
    position: absolute;
    left: 30%;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background-color: #f5f7fa;
    border-radius: 50%;
    box-shadow: 0 -30px 0 #f5f7fa, 0 30px 0 #f5f7fa;
} */

.coupon-left {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    padding: 0 10px;
}

.coupon-amount {
    font-size: 36px;
    font-weight: bold;
}

.coupon-condition {
    font-size: 14px;
    margin-top: 5px;
}

.coupon-right {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 15px;
}

.coupon-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.coupon-scope {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.coupon-expiry {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
}

.coupon-right .el-button {
    align-self: flex-end;
    padding: 4px 16px;
}

/* 其他现有样式... */
.address-form {
    padding: 20px 0;
}

.form-row {
    display: flex;
    margin-bottom: 20px;
}

.form-item {
    flex: 1;
    margin-right: 20px;
}

.form-item:last-child {
    margin-right: 0;
}

.form-item.full-width {
    flex: 1 0 100%;
}

.form-item label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.tag-options {
    margin-top: 8px;
}

.tag-options .el-button {
    padding: 4px 12px;
    font-size: 12px;
    margin-right: 8px;
}

.gender-options {
    margin-top: 8px;
}

.dialog-footer {
    text-align: center;
    margin-top: 20px;
}

.dialog-footer .el-button {
    width: 120px;
}
</style>